// The 30-facet breakdown, extracted from careers.co.jp's
// routes/candidate/BigFive.tsx (FacetReport) so the candidate results view
// and the admin detail view render the identical report. Facet scores are
// raw reverse-adjusted sums (4 items → 4..20), shown against their own
// min/max — these are not percentiles.

import { Card, CardBody } from "@/components/ui/card";
import { DOMAIN_META, FACET_LABELS } from "@/lib/bigfiveMeta";
import type { BigFiveFacetScores } from "@careers/shared";

export function FacetReport({
  facets,
  lang,
}: {
  facets: BigFiveFacetScores;
  lang: "en" | "ja";
}) {
  return (
    <Card className="mt-5">
      <CardBody className="space-y-5">
        <h2 className="font-serif text-xl">
          {lang === "ja" ? "ファセット詳細" : "Facet breakdown"}
        </h2>
        {DOMAIN_META.map((d) => {
          const rows = facets[d.key] ?? [];
          if (rows.length === 0) return null;
          return (
            <div key={d.key}>
              <p className="text-sm font-semibold" style={{ color: d.color }}>
                {lang === "ja" ? d.ja : d.en}
              </p>
              <div className="mt-2 space-y-2">
                {rows.map((f) => {
                  const label = FACET_LABELS[d.key][f.facet - 1];
                  const max = f.count * 5;
                  const min = f.count;
                  const pct = max > min ? ((f.score - min) / (max - min)) * 100 : 0;
                  return (
                    <div key={f.facet}>
                      <div className="flex items-baseline justify-between text-[13px]">
                        <span className="text-ink">
                          {label ? (lang === "ja" ? label.ja : label.en) : `#${f.facet}`}
                        </span>
                        <span className="tabular-nums text-ink-muted">
                          {f.score}/{max}
                        </span>
                      </div>
                      <div className="mt-1 h-1.5 rounded-full bg-paper-sunken overflow-hidden">
                        <div
                          className="h-full rounded-full"
                          style={{ width: `${pct}%`, backgroundColor: d.color }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </CardBody>
    </Card>
  );
}
